module.exports = __webpack_public_path__ + "static/img/logo04.8b75ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo04.jpg
// module id = CapE
// module chunks = 1